export default __webpack_public_path__ + "static/media/python.b26465e3.svg";